import React from 'react';
import './ZoomEditor.css';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Rootstate } from '../../store';
import { setZoom } from '../../reducers/zoom/zoomReducerActions';
import Input from '../UI/Input';

const ZoomEditor = () => {

    const zoom = useSelector((state: Rootstate) => state.zoom.zoom, shallowEqual);
    const dispatch = useDispatch();

    const handleZoomChange = (newZoom: number) => {
        dispatch(setZoom(Math.max(1, Math.min(3,newZoom))));
    };

    return (
        <div
            className={'zoom-editor bg-deep-blue rounded-lg pl-3 pr-3 pt-3 pb-3'
            + ' absolute right-6 bottom-6 flex flex-col items-center gap-y-4'}
        >
            <Input
                onChange={(e) => handleZoomChange(parseInt(e.target.value ?? 0)/10)}
                value={zoom * 10}
                id="zoom-slider"
                min="10"
                max="30"
                step="1"
                type="range"
                className='w-8'
            />
        </div>
    );
};
export default ZoomEditor;
